import axios from '../../../axios';
import IClientSettings from '../types/IClientSettings';
import IUpdateStatus from '../types/IUpdateStatus';

const url = 'invoicingservice/api/';

export const getAllFileCategoriesSettings = () => axios.get(`${url}get-all-file-categories`);

export const getCurrentWorkspaceFileCategories = () =>
  axios.get(`${url}file-categories/active/current-workspace`);

export const createNewFileCategory = (requestEntity: IClientSettings) =>
  axios.post(`${url}create-new-file-category`, requestEntity);

export const updateFileCategory = (requestEntity: IClientSettings) =>
  axios.put(`${url}update-file-category`, requestEntity);

export const updateFileCategoryStatus = (id: string, status: IUpdateStatus) =>
  axios.put(`${url}file-categories/update-status/${id}`, status);
